<template>
  <generic-modal :title="$t('booking')" ref="generic_modal">
    <div>
      <figure class="image is-128x128 is-pulled-right">
        <v-lazy-image
          v-if="this.class.settings && this.class.settings.coach_photo"
          :src="`${api_host}/drive/static/${this.class.settings.coach_photo.final_name}`"
        />
        <img
          v-else
          src="https://cdn-icons-png.flaticon.com/512/6833/6833573.png"
        />
      </figure>
      <div class="title is-3">
        {{ this.class.coach }}
      </div>
      <div class="title is-3">
        {{ format_date(this.start_at) }}
        {{ moment(this.class.start_date).format("HH:mm") }}
      </div>
      <div class="tags has-addons">
        <span class="tag is-info is-large">
          {{ this.class.booking_count }} / {{ this.class.maximum_capacity }}
        </span>
        <span class="tag is-large">
          {{ $t("assistants") }}
        </span>
      </div>
      <!-- <pre>{{ this.class }}</pre> -->
    </div>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <!-- <button
        class="button is-primary is-rounded"
        @click="check_availability"
        :disabled="is_form_invalid"
        v-show="!availability_checked"
      >
        <span class="icon">
          <i class="fa fa-search"></i>
        </span>
        <span>{{ $t("check availability") }}</span>
      </button> -->
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
        v-if="!this.class.is_current_user_booked"
      >
        <span class="icon">
          <i class="fa fa-calendar"></i>
        </span>
        <span>{{ $t("book now") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("close") }}</span>
      </button>
      <button
        class="button is-rounded is-danger"
        @click="cancel_booking"
        v-if="this.class.is_current_user_booked"
      >
        <span class="icon">
          <i class="fa fa-calendar"></i>
        </span>
        <span>{{ $t("cancel booking") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  del,
  error_alert,
  api_host,
  generate_error_message_text,
  get_currency_settings,
  format_date,
  confirm_deletion_dialog,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import VLazyImage from "v-lazy-image";
// import GenericCalendar from "@/components/generic_calendar/Index.vue";
import moment from "moment";
import { v4 } from "uuid";

export default {
  name: "BookingModal",
  components: { GenericModal /* GenericCalendar */, VLazyImage },
  data() {
    let v = this;
    return {
      api_host: api_host,
      class: {},
      start_at: "",
      event_uuid: "",
      meta: {},
      error: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      if (v.class.maximum_capacity) {
        return v.class.booking_count >= v.class.maximum_capacity;
      } else {
        return true;
      }
    },
    available_stations() {
      let v = this;
      if (v.class.maximum_capacity) {
        return v.class.maximum_capacity - v.class.booking_count;
      } else {
        return 0;
      }
    },
  },
  methods: {
    format_date,
    moment,
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal(event_uuid, date) {
      console.log("show_modal", event_uuid, date);
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.show_modal();
      v.event_uuid = event_uuid;
      v.start_at = date;
      get("/pilates_member/reservation/class", {
        uuid: event_uuid,
        date: date,
        member_uuid: v.$route.params.uuid,
      })
        .then((r) => {
          v.class = r;
          if (r.booking_count >= r.maximum_capacity) {
            v.error = v.$t("this class is full");
          }
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
    save() {
      let v = this;
      put("/pilates_member/reservation", {
        event_uuid: v.event_uuid,
        date: v.start_at,
        member_uuid: v.$route.params.uuid,
      })
        .then((r) => {
          v.$emit("booking_made", r);
          v.$refs.generic_modal.close_modal();
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        settings: {},
      };
      v.error = "";
      v.class = {};
      v.start_at = "";
      v.event_uuid = "";
    },
    check_availability() {
      let v = this;
      post("/pilates_member/reservation/availability", {
        ...v.meta,
        date: v.event_info.dateStr,
      })
        .then((available_stations) => {
          // console.log("available_stations", available_stations);
          v.available_stations = available_stations;
          v.availability_checked = true;
          v.error = "";
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
    cancel_booking() {
      let v = this;
      confirm_deletion_dialog(
        v.$t("are you sure to cancel booking?"),
        v,
        function () {
          console.log("cancel booking");
          del("/pilates_member/reservation", {
            uuid: v.class.booking_uuid,
          })
            .then((r) => {
              v.$emit("booking_canceled", r);
              v.close_modal();
            })
            .catch((error) => {
              v.error = generate_error_message_text(error);
            });
        }
      );

      // put("/pilates_member/reservation/cancel", {
      //   event_uuid: v.event_uuid,
      //   date: v.start_at,
      //   member_uuid: v.$route.params.uuid,
      // })
      //   .then((r) => {
      //     v.$emit("booking_made", r);
      //     v.$refs.generic_modal.close_modal();
      //   })
      //   .catch((error) => {
      //     v.error = generate_error_message_text(error);
      //   });
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
